import type { Nullable } from "@eroad/types";

import { Driver } from "../../../drivers/Driver";
import type { DriverOptionsByText } from "../../../drivers/types";
import { SPIN_TEST_ID } from "./constants";

/**
 * Spin driver is used to test and interact with the Spin component in unit tests.
 *
 * @example
 * ```ts
 * const spinDriver = new SpinDriver(); // uses default test id to locate the Spin component
 * const spinDriver = new SpinDriver("spin-test-id"); // uses provided test id to locate the Spin component
 * const spinDriver = new SpinDriver(undefined, container); // uses default test id within a specific container
 * ```
 */
class SpinDriver extends Driver<HTMLDivElement> {
  constructor(selector?: DriverOptionsByText | string, container?: Nullable<HTMLElement>) {
    super(selector ?? SPIN_TEST_ID, container);
  }
}

export { SpinDriver };
